import api from "./Api";

export const submitContactMessage = (data) => api.post("Service/contact", data);
